import styled from 'styled-components';

import { StyledH3 } from '../../../Styled';

interface H3Props {
  typeColour: string;
}

const H3 = styled(StyledH3)<H3Props>`
  margin-bottom: 5px;

  span.type {
    color: ${(props) => props.typeColour};
  }

  span.cost {
    font-weight: normal;
  }
`;

export default H3;
